// Mock data for Common App clone

export const mockColleges = [
  {
    id: '1',
    name: 'Harvard University',
    location: 'Cambridge, MA',
    type: 'Private',
    size: 'Medium',
    acceptance_rate: 3.4,
    tuition: 54000,
    image: 'https://images.unsplash.com/photo-1562774053-701939374585?w=400',
    description: 'Founded in 1636, Harvard is the oldest institution of higher education in the United States.',
    deadline: '2024-01-01',
    requirements: ['Common App Essay', 'Supplemental Essays', 'Transcripts', 'Test Scores (Optional)', '2 Teacher Recommendations'],
    majors: ['Computer Science', 'Economics', 'Biology', 'Political Science', 'Engineering']
  },
  {
    id: '2',
    name: 'Stanford University',
    location: 'Stanford, CA',
    type: 'Private',
    size: 'Medium',
    acceptance_rate: 3.7,
    tuition: 56000,
    image: 'https://images.unsplash.com/photo-1498243691581-b145c3f54a5a?w=400',
    description: 'Stanford University is a leading research university located in Silicon Valley.',
    deadline: '2024-01-05',
    requirements: ['Common App Essay', 'Supplemental Essays', 'Transcripts', 'Test Scores (Optional)', '2 Teacher Recommendations'],
    majors: ['Computer Science', 'Engineering', 'Business', 'Biology', 'Psychology']
  },
  {
    id: '3',
    name: 'MIT',
    location: 'Cambridge, MA',
    type: 'Private',
    size: 'Small',
    acceptance_rate: 4.1,
    tuition: 53000,
    image: 'https://images.unsplash.com/photo-1564981797816-1043664bf78d?w=400',
    description: 'Massachusetts Institute of Technology is renowned for science and technology education.',
    deadline: '2024-01-01',
    requirements: ['Common App Essay', 'MIT-specific Essays', 'Transcripts', 'Test Scores (Required)', '2 Teacher Recommendations'],
    majors: ['Computer Science', 'Engineering', 'Mathematics', 'Physics', 'Biology']
  },
  {
    id: '4',
    name: 'Yale University',
    location: 'New Haven, CT',
    type: 'Private',
    size: 'Medium',
    acceptance_rate: 4.5,
    tuition: 59000,
    image: 'https://images.unsplash.com/photo-1541339907198-e08756dedf3f?w=400',
    description: 'Yale University is known for its excellent drama and music programs.',
    deadline: '2024-01-02',
    requirements: ['Common App Essay', 'Supplemental Essays', 'Transcripts', 'Test Scores (Optional)', '2 Teacher Recommendations'],
    majors: ['History', 'Political Science', 'Economics', 'English', 'Biology']
  },
  {
    id: '5',
    name: 'Princeton University',
    location: 'Princeton, NJ',
    type: 'Private',
    size: 'Small',
    acceptance_rate: 4.0,
    tuition: 57000,
    image: 'https://images.unsplash.com/photo-1607237138185-eedd9c632b0b?w=400',
    description: 'Princeton is a prestigious Ivy League research university.',
    deadline: '2024-01-01',
    requirements: ['Common App Essay', 'Supplemental Essays', 'Transcripts', 'Test Scores (Optional)', '2 Teacher Recommendations'],
    majors: ['Economics', 'Computer Science', 'Politics', 'Engineering', 'Mathematics']
  },
  {
    id: '6',
    name: 'Columbia University',
    location: 'New York, NY',
    type: 'Private',
    size: 'Medium',
    acceptance_rate: 3.9,
    tuition: 61000,
    image: 'https://images.unsplash.com/photo-1567168544230-d8d9a9e90c0c?w=400',
    description: 'Columbia is an Ivy League university in the heart of New York City.',
    deadline: '2024-01-02',
    requirements: ['Common App Essay', 'Supplemental Essays', 'Transcripts', 'Test Scores (Optional)', '2 Teacher Recommendations'],
    majors: ['Economics', 'Political Science', 'Engineering', 'English', 'Biology']
  },
  {
    id: '7',
    name: 'University of California, Berkeley',
    location: 'Berkeley, CA',
    type: 'Public',
    size: 'Large',
    acceptance_rate: 14.5,
    tuition: 44000,
    image: 'https://images.unsplash.com/photo-1571055107559-3e67626fa8be?w=400',
    description: 'UC Berkeley is a top-ranked public research university.',
    deadline: '2023-11-30',
    requirements: ['Personal Insight Questions', 'Transcripts', 'Test Scores (Optional)', 'Activities List'],
    majors: ['Computer Science', 'Engineering', 'Business', 'Economics', 'Biology']
  },
  {
    id: '8',
    name: 'UCLA',
    location: 'Los Angeles, CA',
    type: 'Public',
    size: 'Large',
    acceptance_rate: 12.3,
    tuition: 43000,
    image: 'https://images.unsplash.com/photo-1579389083078-4e7018379f7e?w=400',
    description: 'UCLA is a public research university in Los Angeles.',
    deadline: '2023-11-30',
    requirements: ['Personal Insight Questions', 'Transcripts', 'Test Scores (Optional)', 'Activities List'],
    majors: ['Psychology', 'Economics', 'Biology', 'Political Science', 'Engineering']
  }
];

export const mockApplicationStatuses = [
  { college_id: '1', status: 'in_progress', progress: 65, last_updated: '2024-01-15' },
  { college_id: '2', status: 'submitted', progress: 100, last_updated: '2024-01-10', submitted_date: '2024-01-10' },
  { college_id: '5', status: 'not_started', progress: 0, last_updated: '2024-01-05' }
];

export const mockUserData = {
  id: 'user_1',
  email: 'student@example.com',
  firstName: 'Jane',
  lastName: 'Smith',
  phone: '555-0123',
  dateOfBirth: '2006-05-15',
  applicationData: {
    personal: {
      legalFirstName: 'Jane',
      legalMiddleName: 'Marie',
      legalLastName: 'Smith',
      preferredName: 'Jane',
      dateOfBirth: '2006-05-15',
      email: 'jane.smith@email.com',
      phone: '555-0123',
      address: '123 Main Street',
      city: 'Springfield',
      state: 'IL',
      zipCode: '62701',
      country: 'United States',
      citizenship: 'US Citizen'
    },
    family: {
      parent1FirstName: 'John',
      parent1LastName: 'Smith',
      parent1Email: 'john.smith@email.com',
      parent1Occupation: 'Engineer',
      parent1Education: "Bachelor's Degree",
      parent2FirstName: 'Mary',
      parent2LastName: 'Smith',
      parent2Email: 'mary.smith@email.com',
      parent2Occupation: 'Teacher',
      parent2Education: "Master's Degree",
      siblings: 1,
      householdIncome: '$75,000-$100,000'
    },
    education: [
      {
        schoolName: 'Springfield High School',
        city: 'Springfield',
        state: 'IL',
        startDate: '2022-08',
        endDate: '2026-06',
        gpa: 3.85,
        gpaScale: 4.0,
        classRank: 25,
        classSize: 400
      }
    ],
    testing: {
      sat: { total: 1450, math: 750, reading: 700, date: '2023-10' },
      act: null,
      apExams: [
        { subject: 'AP Calculus AB', score: 5, year: 2023 },
        { subject: 'AP English Language', score: 4, year: 2023 }
      ]
    },
    activities: [
      {
        name: 'Debate Team',
        type: 'Academic',
        position: 'Captain',
        description: 'Led team to state championships, mentored younger members',
        yearsParticipated: ['10', '11', '12'],
        hoursPerWeek: 10,
        weeksPerYear: 36
      },
      {
        name: 'Volunteer Tutoring',
        type: 'Community Service',
        position: 'Volunteer',
        description: 'Tutored underprivileged students in math and science',
        yearsParticipated: ['11', '12'],
        hoursPerWeek: 5,
        weeksPerYear: 40
      }
    ],
    essays: {
      commonAppEssay: {
        prompt: 'Some students have a background, identity, interest, or talent that is so meaningful they believe their application would be incomplete without it. If this sounds like you, then please share your story.',
        content: 'Growing up in a multilingual household shaped my perspective on communication and understanding...'
      },
      supplementalEssays: {}
    }
  }
};

export const essayPrompts = [
  'Some students have a background, identity, interest, or talent that is so meaningful they believe their application would be incomplete without it. If this sounds like you, then please share your story.',
  'The lessons we take from obstacles we encounter can be fundamental to later success. Recount a time when you faced a challenge, setback, or failure. How did it affect you, and what did you learn from the experience?',
  'Reflect on a time when you questioned or challenged a belief or idea. What prompted your thinking? What was the outcome?',
  'Reflect on something that someone has done for you that has made you happy or thankful in a surprising way. How has this gratitude affected or motivated you?',
  'Discuss an accomplishment, event, or realization that sparked a period of personal growth and a new understanding of yourself or others.',
  'Describe a topic, idea, or concept you find so engaging that it makes you lose all track of time. Why does it captivate you? What or who do you turn to when you want to learn more?',
  'Share an essay on any topic of your choice. It can be one you\'ve already written, one that responds to a different prompt, or one of your own design.'
];